import Vue from 'vue'
import vueRouter from 'vue-router'
Vue.use(vueRouter)

export default new vueRouter({
    routes: [
        {
            path: '/index',
            component: () => import('../views/newHome.vue')
        },
        {
            path: '/newHome',
            component: () => import('../views/newHome.vue')
        },
        {
            path: '/login',
            component: () => import('../views/Login.vue')
        },
        {
            path: '/user',
            component: () => import('../views/User.vue')
        },
        {
            path: '/packDetail',
            component: () => import('../views/packDetail/index.vue')
        },
        // {
        //     path: '/morePack',
        //     component: () => import('../views/morePack/index.vue')
        // },
        // {
        //     path: '/moreCoupon',
        //     component: () => import('../views/moreCoupon/index.vue')
        // },
        {
            path: '/couponDetail',
            component: () => import('../views/couponDetail/index.vue')
        },
        {
            path: '/myCoupon',
            component: () => import('../views/myCoupon/index.vue')
        },
        {
            path: '/newHome/morePack',
            component: () => import('../views/morePack/homeMore.vue')
        },
        {
            path: '/newHome/moreCoupon',
            component: () => import('../views/moreCoupon/homeMore.vue')
        }
        // {
        //     path: '/points',
        //     component: () => import('../views/points/index.vue')
        // }
    ]
}) 


// WEBPACK FOOTER //
// ./src/router/index.js